import { CommandBase } from "../../../common/services/cqs/commandManager";
import { IPrimaryKey } from "../../../common/services/cqs/IPrimaryKey";

export class UpdateAtgardAvslutaArbetsorderGrotCommand extends CommandBase {
    atgardId: number;
    atgardUtford?: boolean;
    grotLamnatPaHygge?: boolean;

    get primaryKey(): IPrimaryKey<UpdateAtgardAvslutaArbetsorderGrotCommand> {
        return {
            atgardId: this.atgardId
        };
    }

    constructor(init: (instance: UpdateAtgardAvslutaArbetsorderGrotCommand) => void) {
        super("UpdateAtgardAvslutaArbetsorderGrotCommand");
        init(this);
    }
}
